import { useDispatch, useSelector } from 'react-redux';
import { useContext, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie'
import BeforeUnloadComponent from 'react-beforeunload-component';
import { Box, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import './beforeUnload.scss';
import './uploadingFile.scss';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';

import { VideoEditModule } from './videoEdit.module';
import { WebGLContextProvider } from '../../component/video-edit/videoEdit.provider';

import { useGlobalContext } from '../../provider';
import { loginState_Store } from '../../store/actions/mainAction';

import { WebGLContext, webGlSizeOptions } from '../../component/video-edit/videoEdit.config';
import { VideoElements_Store, imageElements_Store, MoveableDivArray_Store, dataLoaded_Store, audioElements_Store } from '../../store/actions/webgldata';
import { ProjectUUID_Store, ProjectJSON_Store, changedJSON_Store, saveState_Store, sequenceStatus_Store, sequenceNum_Store, captureThumbnailFlag_store, addedTemplate_store, editSubtitle_Store } from '../../store/actions/projectdata';

import { Collaborations } from '../../component/collaborative/collaborations';

import { GetProjectUUID } from '../../assets/script/commonFunction';
import { TimeCount_Store } from '../../store/actions/videoPlayAction';
import { getProjectJSON, getProjectJSONWithME, updateProjectJSON } from '../../axios/ApiProvider';
import { copyObject, getSelectedType, getWebglResizeJson, linkactive } from '../../component/video-edit/commonFunction';
import { getTotalProjectTime } from '../../component/video-edit/timeline/common/commonFunction';
import { getVideoElements, getImageElements, ResetServerInformation, getVideoWebGLElements, getTextWebGLElements, getImageWebGLElements } from '../../component/video-edit/webGL/commonFunc';
const HOME_FRONTEND_URL = process.env.REACT_APP_BASE_FRONTEND_HOME_URL

let mobileScreenDetect = false
  if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(navigator.userAgent||navigator.vendor||window.opera)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent||navigator.vendor||window.opera).substr(0,4))){
    mobileScreenDetect = true;
  }

export const VideoEditCotainer = () => {
  const [uploading, setUploading] = useState([]);
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  const uploadingFiles = useSelector((store) => store.projectdata.uploadingFiles);
  useEffect(() => {
    let processing = [];
    let keys = Object.keys(uploadingFiles);
    keys.forEach((key) => {
      let file = uploadingFiles[key];
      if (!file.state) processing.push(file);
    })
    setUploading(processing);
  }, [uploadingFiles])

  const [openUploading, setOpenUploading] = useState(false);

  return (
    <>
      <WebGLContextProvider >
        <GetJsonProject />
      </WebGLContextProvider >

      <BeforeUnloadComponent
        ignoreChildrenLinks={true}
        blockRoute={!!uploading.length}
        modalComponentHandler={({ handleModalLeave, handleModalCancel }) =>
          <MyModal onClose={handleModalCancel} onSubmit={handleModalLeave} />
        }
      />

      {!!uploading.length && (
        <div className='uploadingFiles-wrapper'>
          <div className={`uploading-header${openUploading ? '-open' : ''}`}
            onClick={() => { setOpenUploading(!openUploading); }}
          >
            <span>{languageStrs.uploading_files}</span>
            {openUploading ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </div>

          <div className={`uploading-body${!openUploading ? '-hidden' : ''} v-scroll`}>
            {uploading.map((file, key) => (
              <div className='uploading-item' key={key}>
                <Typography variant='h2'>{file.name}</Typography>
                <CircularProgressWithLabel value={file.pc} />
              </div>
            ))}
          </div>
        </div>
      )}
      <Collaborations />
    </>
  )
}

const GetJsonProject = () => {
  const dispatchStore = useDispatch();
  
  const [globalState, { dispatch }] = useGlobalContext()

  const projectUUID = GetProjectUUID();
  
  const [webGLContext] = useContext(WebGLContext);
  const projectJSON = useSelector(store => store.projectdata.projectJSON);
  const changedJSON = useSelector(store => store.projectdata.changedJSON);
  const sequenceNumber = useSelector((store) => store.projectdata.sequenceNumber);
  const activeVideoUUID = useSelector(store => store.projectdata.activeVideoUUID);
  const activeTextUUID = useSelector(store => store.projectdata.activeTextUUID);
  const activeImageUUID = useSelector(store => store.projectdata.activeImageUUID);
  const sequenceStatus = useSelector(store => store.projectdata.sequenceStatus);
  const selectedItemID = useSelector(store => store.webgldata.selectedItemID);
  const saveState = useSelector(store => store.projectdata.saveState);
  const isAddedTemplate = useSelector(store => store.projectdata.addedTemplate);
  
  const [userData, setUserData] = useState({})
  const loginState = useSelector((store) => store.maindata.loginState)
  
  useEffect(() => {
    let tempData = {}
    let item = localStorage.getItem('user_data')
    if (!!item && JSON.parse(item)?.state === 'loggedin') {
      tempData = JSON.parse(item)
    }

    setUserData(tempData)
  }, [loginState])

  useEffect(() => {
    if (!selectedItemID) return;

    let type = getSelectedType(selectedItemID, projectJSON);
    
    // if (type === 'text' && !mobileScreenDetect) {
    if (type === 'text') {
      if(projectJSON.text[selectedItemID].is_subtitle){
        linkactive(5, 5, dispatchStore, true)  
      }else{
        linkactive(9, 9, dispatchStore, false)
      }
      
    }
  }, [selectedItemID])

  const [FirstLoad, SetFirstLoad] = useState(false);
  const videoElements = useSelector(store => store.webgldata.videoElements);
  const imageElements = useSelector(store => store.webgldata.imageElements);
  const DisplaySizeChange = useSelector((store) => store.maindata.DisplaySizeChange);

  useEffect(() => {
    dispatchStore(ProjectUUID_Store(projectUUID));
  }, [projectUUID]);
  //const [addedTemplate, setAddedTemplate] = useState(false);
  useEffect(() => {
    const keys = Object.keys(projectJSON).length;
    if (!projectUUID || !keys || !saveState) return;
    if (!sequenceStatus) {
      dispatchStore(sequenceStatus_Store(true));
      return;
    }

    
    (async () => {
      const totalTime = await getTotalProjectTime(projectJSON);
      if (!totalTime && totalTime !== 0) return;

      if (totalTime !== projectJSON.duration) {
        const newProjectJSON = { ...projectJSON, duration: totalTime }
        dispatchStore(ProjectJSON_Store(newProjectJSON));
      } else {
        let tempSeqState = false
        const tempJSON = {...projectJSON}
        const videos = tempJSON.videos
        const images = tempJSON.images
        const texts = tempJSON.text

        const videoKeys = Object.keys(videos)
        const imageKeys = Object.keys(images)
        const textKeys = Object.keys(texts)

        videoKeys.forEach((key, index) => {
          if (videos[key].sequence !== index) {
            videos[key].sequence = index
            tempSeqState = true
          }
        })

        imageKeys.forEach((key, index) => {
          if (images[key].sequence !== index) {
            images[key].sequence = index
            tempSeqState = true
          }
        })

        textKeys.forEach((key, index) => {
          if (texts[key].sequence !== index) {
            texts[key].sequence = index
            tempSeqState = true
          }
        })
        let videoGroupIds = [];
        const tmpVideoKeys = Object.keys(tempJSON.videos);
        tmpVideoKeys.map(keyItem => {
          if(!videoGroupIds.includes(tempJSON.videos[keyItem].groups)){
            videoGroupIds.push(tempJSON.videos[keyItem].groups);
          }
        })

        let audioGroupIds = [];
        const tmpAudioKeys = Object.keys(tempJSON.audios);
        tmpAudioKeys.map(akeyItem => {
          if(!audioGroupIds.includes(tempJSON.audios[akeyItem].groups)){
            audioGroupIds.push(tempJSON.audios[akeyItem].groups);
          }
        })
        
        let imageGroupIds = [];
        const tmpImageKeys = Object.keys(tempJSON.images);
        tmpImageKeys.map(iKeyitem => {
          if(!imageGroupIds.includes(tempJSON.images[iKeyitem].groups)){
            imageGroupIds.push(tempJSON.images[iKeyitem].groups);
          }
        })
        
        let textGroupIds = [];
        const tmpTextKeys = Object.keys(tempJSON.text);
        tmpTextKeys.map(tKeyitem => {
          if(!textGroupIds.includes(tempJSON.text[tKeyitem].groups)){
            textGroupIds.push(tempJSON.text[tKeyitem].groups);
          }
        })
        tempJSON.timelinerowlabel.video = videoGroupIds
        tempJSON.timelinerowlabel.audio = audioGroupIds
        tempJSON.timelinerowlabel.image = imageGroupIds
        tempJSON.timelinerowlabel.text = textGroupIds
        
        if (tempSeqState) {
          dispatchStore(ProjectJSON_Store(tempJSON));
        } else {
          const newProjectAssets = {}
          const projectAssets = {...projectJSON.asset};
          Object.keys(projectAssets).map(key => {
            const {localThumbnail, ...asset} = projectAssets[key]
            newProjectAssets[key] = {
              ...asset
            }
          })

          // let collaborative = {};
          // let userDatatmp = {
          //   user: "xperson@gmail.com",
          //   first_name : "xperson",
          //   last_name: "xpersonlastname",
          //   coordinate_x : 0.04,
          //   coordinate_y : 0.24,
          //   changed_at : new Date()
          // }
          // let newUUID = uuidv4();
          // if(loginState){
          //   newUUID = userData.uuid;
          // }
          // if(projectJSON.collaborations){
          //   collaborative = projectJSON.collaborations;
          //   collaborative = {...collaborative, [newUUID]: userDatatmp}
          // }else{
          //   collaborative = {[newUUID]: userDatatmp}
          // }

          const newProjectJSON = {
            ...projectJSON,
            asset: newProjectAssets,
          };
          let videoGroupIds = [];
          const tmpVideoKeys = Object.keys(newProjectJSON.videos);
          tmpVideoKeys.map(keyItem => {
            if(!videoGroupIds.includes(newProjectJSON.videos[keyItem].groups)){
              videoGroupIds.push(newProjectJSON.videos[keyItem].groups);
            }
          })

          let audioGroupIds = [];
          const tmpAudioKeys = Object.keys(newProjectJSON.audios);
          tmpAudioKeys.map(akeyItem => {
            if(!audioGroupIds.includes(newProjectJSON.audios[akeyItem].groups)){
              audioGroupIds.push(newProjectJSON.audios[akeyItem].groups);
            }
          })
          
          let imageGroupIds = [];
          const tmpImageKeys = Object.keys(newProjectJSON.images);
          tmpImageKeys.map(iKeyitem => {
            if(!imageGroupIds.includes(newProjectJSON.images[iKeyitem].groups)){
              imageGroupIds.push(newProjectJSON.images[iKeyitem].groups);
            }
          })
          
          let textGroupIds = [];
          const tmpTextKeys = Object.keys(newProjectJSON.text);
          tmpTextKeys.map(tKeyitem => {
            if(!textGroupIds.includes(newProjectJSON.text[tKeyitem].groups)){
              textGroupIds.push(newProjectJSON.text[tKeyitem].groups);
            }
          })
          newProjectJSON.timelinerowlabel.video = videoGroupIds
          newProjectJSON.timelinerowlabel.audio = audioGroupIds
          newProjectJSON.timelinerowlabel.image = imageGroupIds
          newProjectJSON.timelinerowlabel.text = textGroupIds
          
          let response = await updateProjectJSON(projectUUID, {
            ...newProjectJSON, sequence: sequenceNumber.c + 1
          });
          
          if (response.state !== 'success') return;
          let sequence = response.data[projectUUID]?.sequence;
          dispatchStore(sequenceNum_Store({ m: sequence, c: sequence }));
          
          if(isAddedTemplate){
            const JsonData = response.data[projectUUID]  
            dispatchStore(addedTemplate_store(false));
            console.log('Adding Template JSON STORE')
            window.location.reload();
            // await reloadAddedTemplateJSON(JsonData);
          }
        }
      }
    })()
  }, [projectJSON]);

  useEffect(() => {
    if (FirstLoad) {
      setTimeout(() => {
        dispatchStore(saveState_Store(true))
      }, 500);
    }
  }, [FirstLoad]);

 
  useEffect(() => {
    if (!changedJSON) return;
    let newProjectJSON = {
      ...projectJSON,
      timelinerowlabel: {},
      audios: { ...projectJSON.audios, ...changedJSON.audios },
      videos: { ...projectJSON.videos, ...changedJSON.videos },
      images: { ...projectJSON.images, ...changedJSON.images },
      asset: { ...projectJSON.asset, ...changedJSON.asset },
      text: changedJSON?.subtitleUpdated? changedJSON.text :{ ...projectJSON.text, ...changedJSON.text },
      title: changedJSON.title ? changedJSON.title : projectJSON.title,
    }

    let videoGroupIds = [];
    const tmpVideoKeys = Object.keys(newProjectJSON.videos);
    tmpVideoKeys.map(keyItem => {
      if(!videoGroupIds.includes(newProjectJSON.videos[keyItem].groups)){
        videoGroupIds.push(newProjectJSON.videos[keyItem].groups);
      }
    })

    let audioGroupIds = [];
    const tmpAudioKeys = Object.keys(newProjectJSON.audios);
    tmpAudioKeys.map(akeyItem => {
      if(!audioGroupIds.includes(newProjectJSON.audios[akeyItem].groups)){
        audioGroupIds.push(newProjectJSON.audios[akeyItem].groups);
      }
    })
    
    let imageGroupIds = [];
    const tmpImageKeys = Object.keys(newProjectJSON.images);
    tmpImageKeys.map(iKeyitem => {
      if(!imageGroupIds.includes(newProjectJSON.images[iKeyitem].groups)){
        imageGroupIds.push(newProjectJSON.images[iKeyitem].groups);
      }
    })
    
    let textGroupIds = [];
    const tmpTextKeys = Object.keys(newProjectJSON.text);
    tmpTextKeys.map(tKeyitem => {
      if(!textGroupIds.includes(newProjectJSON.text[tKeyitem].groups)){
        textGroupIds.push(newProjectJSON.text[tKeyitem].groups);
      }
    })
    newProjectJSON.timelinerowlabel.video = videoGroupIds
    newProjectJSON.timelinerowlabel.audio = audioGroupIds
    newProjectJSON.timelinerowlabel.image = imageGroupIds
    newProjectJSON.timelinerowlabel.text = textGroupIds
    

    if (changedJSON?.flag) {
      const tempChangeKeys = Object.keys(changedJSON.videos)
      const tempVideoKeys = Object.keys(newProjectJSON.videos)
      if (tempVideoKeys.length === 1 && tempChangeKeys.length === 1) {
        let tempVideo = changedJSON.videos[tempChangeKeys[0]]
        let tempHeight = tempVideo.dimension.h
        let tempWidth = tempVideo.dimension.w

        let tempOption = webGlSizeOptions[0]
        if (tempHeight / tempWidth <= 1) {
          tempOption = webGlSizeOptions[2]
        }

        let flagheight = tempOption.wSize.height !== newProjectJSON.height
        let flagwidth = tempOption.wSize.width !== newProjectJSON.width

        if (flagheight || flagwidth) {
          const { videoitems, imageitems } = getWebglResizeJson(newProjectJSON, tempOption, videoElements, imageElements)
          newProjectJSON = { ...newProjectJSON, ...tempOption.wSize, videos: videoitems, images: imageitems }
        }
      }
    }
    
    dispatchStore(ProjectJSON_Store(newProjectJSON));
    dispatchStore(changedJSON_Store(null));
  }, [changedJSON])
  const [calledProjectAPI, setCalledProjectAPI] = useState(false);
  useEffect(() => {
    if (!!webGLContext?.activeModelViewMatrices && !FirstLoad) {
      if(calledProjectAPI == false){
        setCalledProjectAPI(true);
        getServerProjectJSON();
      }
    }
  }, [webGLContext])

  const [accessible, setAccessible] = useState(true);
  const [isAccessModal, setIsAccessModal] = useState(true);

  const [cookies, setCookie, removeCookie] = useCookies(['csrftoken']);

  const setUserAuthToken = async (userData) => {
		let expires = new Date();
		localStorage.setItem('user_data', null);
		let signed = userData['state'].localeCompare('loggedin') === 0;

		if (!!signed) {
			dispatch({ type: 'userData', payload: userData })

			dispatchStore(loginState_Store(true))
			expires.setTime(expires.getTime() + 24 * 60 * 60 * 1000);
			setCookie('csrftoken', userData.token, { path: '/', expires })
			localStorage.setItem('user_data', JSON.stringify(userData));
		} else removeCookie('csrftoken', { path: '/', expires });
	};

  const reloadAddedTemplateJSON = async (JSONdata) => {
    try {
      
      dispatchStore(dataLoaded_Store(false))
      let tempJSON = copyObject(JSONdata)
      if (!tempJSON?.audios) tempJSON.audios = {}

      const videos = copyObject(tempJSON.videos)
      const images = copyObject(tempJSON.images)
      const texts = copyObject(tempJSON.text)

      const videoKeys = Object.keys(videos)
      const imageKeys = Object.keys(images)
      const textKeys = Object.keys(texts)

      videoKeys.sort((key1, key2) => (
        videos[key1].sequence - videos[key2].sequence
      ))

      imageKeys.sort((key1, key2) => (
        images[key1].sequence - images[key2].sequence
      ))

      textKeys.sort((key1, key2) => (
        texts[key1].sequence - texts[key2].sequence
      ))

      let tempTexts = {}
      let tempImages = {}
      let tempVideos = {}
      textKeys.forEach((key) => { tempTexts[key] = texts[key] })
      imageKeys.forEach((key) => { tempImages[key] = images[key] })
      videoKeys.forEach((key) => { tempVideos[key] = videos[key] })

      tempJSON.videos = tempVideos
      tempJSON.images = tempImages
      tempJSON.text = tempTexts
      await getVideoElements(tempJSON, async (videoElements, audioElements, type) => {
        const videoElKeys = Object.keys(videoElements);
        dispatchStore(VideoElements_Store(videoElements));
        dispatchStore(audioElements_Store(audioElements));
      
        if (type === 'unloaded' || !videoElKeys.length) {
          await getImageElements(tempJSON, (imgElements) => {
            dispatchStore(imageElements_Store(imgElements))
         })
        }

        let sequence = tempJSON.sequence;
        dispatchStore(ProjectJSON_Store(tempJSON));
        dispatchStore(sequenceNum_Store({ m: sequence, c: sequence }));
        // dispatchStore(dataLoaded_Store(true))
        if (type === 'loaded') {
          SetFirstLoad(true);
          dispatchStore(dataLoaded_Store(true))
          setTimeout(()=>{dispatchStore(captureThumbnailFlag_store(true))}, 2000);
        }
      })
    }catch(err) {
      console.log(err);
    }
  }

  const getServerProjectJSON = async () => {
    
    try {
      const JSONdata = await getProjectJSONWithME(projectUUID);
      if (JSONdata.state === 'error') {
        throw new Error("get project json error")
      }

      if(JSONdata.data.Code == "Access Denied"){
        Swal.fire({
          position: "center",
          icon: "warning",
          title: "The project does not exist (or private). Returning to main screen.",
          showConfirmButton: true,
          confirmButtonText: "Okay",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.href=HOME_FRONTEND_URL;
            // window.location.reload();
          }
        });
      }

      if(JSONdata.data['user']){
        setUserAuthToken(JSONdata.data['user']);
      }

      if (!JSONdata.data.manifest[projectUUID]) {
        setAccessible(false);
        return;
      }
      
      dispatchStore(dataLoaded_Store(false))
      let tempJSON = copyObject(JSONdata.data.manifest[projectUUID])
      if (!tempJSON?.audios) tempJSON.audios = {}

      const videos = copyObject(tempJSON.videos)
      const images = copyObject(tempJSON.images)
      const texts = copyObject(tempJSON.text)

      const videoKeys = Object.keys(videos)
      const imageKeys = Object.keys(images)
      const textKeys = Object.keys(texts)

      videoKeys.sort((key1, key2) => (
        videos[key1].sequence - videos[key2].sequence
      ))

      imageKeys.sort((key1, key2) => (
        images[key1].sequence - images[key2].sequence
      ))

      textKeys.sort((key1, key2) => (
        texts[key1].sequence - texts[key2].sequence
      ))

      let tempTexts = {}
      let tempImages = {}
      let tempVideos = {}
      textKeys.forEach((key) => { tempTexts[key] = texts[key] })
      imageKeys.forEach((key) => { tempImages[key] = images[key] })
      videoKeys.forEach((key) => { tempVideos[key] = videos[key] })

      tempJSON.videos = tempVideos
      tempJSON.images = tempImages
      tempJSON.text = tempTexts

      await getVideoElements(tempJSON, async (videoElements, audioElements, type) => {
        const videoElKeys = Object.keys(videoElements);

        dispatchStore(VideoElements_Store(videoElements));
        dispatchStore(audioElements_Store(audioElements));

       // if (type === 'unloaded' || !videoElKeys.length) {
          await getImageElements(tempJSON, (imgElements) => {
            
            dispatchStore(imageElements_Store(imgElements))
         })
        //}

        let sequence = tempJSON.sequence;
        dispatchStore(ProjectJSON_Store(tempJSON));
        dispatchStore(sequenceNum_Store({ m: sequence, c: sequence }));
        
        if (type === 'loaded') {

          SetFirstLoad(true);
          dispatchStore(dataLoaded_Store(true))
          // setTimeout(()=>{dispatchStore(captureThumbnailFlag_store(true))}, 2000);
        }
      })
    } catch (err) {
      dispatchStore(dataLoaded_Store(true))
      return;
    }
  }

  useEffect(() => {
    getWebGLElements();

  }, [videoElements, imageElements])

  useEffect(() => {
    
    getWebGLElements();
    
  }, [activeVideoUUID, activeTextUUID, activeImageUUID])

  const getWebGLElements = async () => {
    
    if (!webGLContext.webGLRef || !webGLContext.activeModelViewMatrices) return;
    const activeMatrices = webGLContext.activeModelViewMatrices;
    const activeTextures = webGLContext.activeTextures;
    const activeBuffers = webGLContext.activeBuffers;
    const activeTextCanvases = webGLContext.activeTextCanvases;
    const activeKeys = [...activeVideoUUID, ...activeTextUUID, ...activeImageUUID];
    
    const matricesKeys = [...activeMatrices.keys()];
    matricesKeys.forEach((key) => {
      const checkActiveKey = activeKeys.find((activeKey) => activeKey === key);
      if (!checkActiveKey) {
        activeMatrices.delete(key);
        activeTextures.delete(key);
        activeBuffers.delete(key);
        activeTextCanvases.delete(key);
      }
    })
    
    const [videoMoveableDivs] = await getVideoWebGLElements(activeVideoUUID, projectJSON, videoElements, webGLContext);
    const [imageMoveableDivs] = await getImageWebGLElements(activeImageUUID, projectJSON, imageElements, webGLContext);
    const [textMoveableDivs] = await getTextWebGLElements(activeTextUUID, projectJSON, webGLContext);
    
    dispatchStore(MoveableDivArray_Store({ ...videoMoveableDivs, ...textMoveableDivs, ...imageMoveableDivs }));

    if (!saveState) {
      setTimeout(() => {
        dispatchStore(TimeCount_Store(new Date(0)))
      }, 10)
    }
  }

  useEffect(() => {
    if (!FirstLoad || !webGLContext.webGLRef) return;
    ResetServerInformation(activeVideoUUID, activeTextUUID, activeImageUUID, projectJSON, webGLContext.webGLRef);
    // dispatchStore(SelectedItemID_Store(null));
  }, [DisplaySizeChange]);

  return (
    <>
      <VideoEditModule />
      {!accessible && (<AccessModal onClose={()=>{
        window.location.href=HOME_FRONTEND_URL;
      }}></AccessModal>)}
    </>
  )
}

const AccessModal = ({onClose})=>{
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  return (
    <div className='unload-modal-wrapper' style={{justifyContent: "center"}}>
      <div className="modal-contain modal-center" style={{position: "relative"}}>
        <h4 style={{textAlign: "center"}}>{languageStrs.project_not_accessible}</h4>
        
        <div className="actions">
          <div className="close-btn m-auto" onClick={onClose}>{languageStrs.okay}</div>
        </div>
      </div>
    </div>
  );
}

const MyModal = ({ onClose, onSubmit }) => {
  const languageStrs = useSelector((store) => store.editdata.languageStrs)
  return (
    <div className='unload-modal-wrapper'>
      <div className='modal-hidden' onClick={onClose} />

      <div className="modal-contain">
        <h4>Pave Leave?</h4>
        <div className="content">
          {languageStrs.ongoing_upload_project_str} <br />
          {languageStrs.leaving_page_sure}
        </div>

        <div className="actions">
          <div className="leave-btn" onClick={onSubmit}>{languageStrs.leave}</div>
          <div className="close-btn" onClick={onClose}>{languageStrs.cancel}</div>
        </div>
      </div>
    </div>
  );
};

const CircularProgressWithLabel = (props) => {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" size={30} {...props} />

      <Box sx={{
        top: 0, left: 0, bottom: 0, right: 0,
        position: 'absolute', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
      }}>
        <Typography variant="body2" sx={{ fontSize: '10px', color: '#005eff !important' }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
}
